<div
  class="flex w-full min-w-max flex-col gap-2 overflow-y-auto"
  role="menu"
  aria-orientation="vertical"
  [attr.aria-labelledby]="'datepicker-dropdown'">
  <div class="flex justify-between gap-2" [class.flex-col]="type() === 'datetime'">
    @for (key of range(); track key) {
      @switch (type()) {
        @case ('date') {
          <div
            [class]="getClassesForPart(key)"
            (click)="onSelectPart(key)"
            (keydown)="onSelectPart(key)"
            [tabindex]="key">
            <div class="flex w-full items-center bg-transparent p-0 text-sm">
              <input
                #firstInput
                [id]="'date-input-' + key"
                [value]="getInputValue(key)"
                (keydown)="onKeyInput($event)"
                (keydown.enter)="onInputChange($event, key)"
                (focusout)="onInputChange($event, key)"
                type="text"
                size="1"
                class="block w-full resize-none border-0 bg-none p-0 outline-none" />
            </div>
          </div>
        }
        @case ('datetime') {
          <div
            [class]="getClassesForPart(key)"
            (click)="onSelectPart(key)"
            (keydown)="onSelectPart(key)"
            (focusin)="onSelectPart(key)"
            [tabindex]="key">
            <div class="flex w-full items-center bg-transparent p-0 text-sm">
              <input
                #firstInput
                [id]="'datetime-date-input-' + key"
                [value]="getInputValue(key)"
                (keydown)="onKeyInput($event)"
                (keydown.enter)="onInputChange($event, key)"
                (focusout)="onInputChange($event, key)"
                type="text"
                size="1"
                class="block w-full resize-none border-0 bg-none p-0 outline-none" />
            </div>
            <div
              class="mx-3 h-full bg-zinc-200 dark:bg-zinc-700"
              style="width: 2px; height: 14px"></div>
            <div class="flex w-full items-center bg-transparent p-0 text-sm">
              <input
                [id]="'datetime-time-input-' + key"
                [value]="getInputValue(key, 'time')"
                (keydown)="onKeyInput($event)"
                (keydown.enter)="onInputChange($event, key, 'time')"
                (focusout)="onInputChange($event, key, 'time')"
                type="text"
                size="1"
                class="block w-full resize-none border-0 bg-none p-0 outline-none" />
            </div>
          </div>
        }
      }
    }
  </div>
  <div class="flex flex-col items-center gap-2">
    <div class="flex w-full items-center justify-between px-2">
      <span class="text-sm font-medium">{{
        focusedMonth() | date: 'MMM yyyy' : undefined : currentLang()
      }}</span>
      <div class="flex gap-1">
        <button
          (click)="previousMonth()"
          class="rounded p-1 text-zinc-600 transition-colors hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-400 dark:hover:bg-zinc-700 dark:hover:text-zinc-100"
          type="button">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        <button
          (click)="nextMonth()"
          class="rounded p-1 text-zinc-600 transition-colors hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-400 dark:hover:bg-zinc-700 dark:hover:text-zinc-100"
          type="button">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>
    </div>

    <table class="max-w-56 table-fixed border-collapse">
      <thead class="border-0">
        <tr class="h-full text-zinc-400 dark:text-zinc-600">
          @for (day of weekDays(); track trackWeekDayString($index, day)) {
            <th
              class="inline-flex size-8 items-center justify-center font-normal select-none">
              {{ day }}
            </th>
          }
        </tr>
      </thead>
      <tbody class="border-0">
        @for (week of monthWeeks(); track trackMonthWeek($index, week)) {
          <tr class="h-full whitespace-nowrap">
            @for (day of week; track trackMonthDay($index, day)) {
              <td
                class="relative inline-flex size-8 items-center justify-center select-none"
                (click)="onDayClick(day.day)"
                (keydown)="onKeyDown($event, day.day)"
                [tabindex]="day.isPartOfCurrentMonth ? 0 : -1"
                [attr.aria-selected]="
                  isFirstInSelectedRange(day.day) || isLastInSelectedRange(day.day)
                "
                [attr.aria-label]="day.day | date: 'fullDate'"
                role="gridcell">
                @if (isInSelectedRange(day.day)) {
                  <div
                    [class.end]="isLastInSelectedRange(day.day)"
                    [class.start]="isFirstInSelectedRange(day.day)"
                    class="range-indicator"></div>
                }
                <div
                  [class]="getDayClasses(day)"
                  class="calendar-day border-2 border-transparent hover:border-blue-500">
                  {{ day.day | date: 'd' }}
                </div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
